<template>
  <div id="confirm_customer_offer" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLiveLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <loading-modal :is-loading="isLoading"></loading-modal>
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content closefriend-modal" style="background-color: #1a1a1a; border: 1px solid rgba(255,255,255,0.1); border-radius: 16px;">
        <div class="modal-header border-0 align-items-center pb-2">
          <button type="button" class="close text-white" @click="back()" style="position: absolute; left: 20px; opacity: 0.8; text-shadow: none;">
            <i class="fa fa-arrow-left font-size-16" aria-hidden="true"></i>
          </button>
          <h4 class="modal-title mx-auto font-size-16 font-weight-bold text-white">Confirm Custom Request</h4>
          <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" style="position: absolute; right: 20px; opacity: 0.8; text-shadow: none;">
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <div class="modal-body text-center pt-0 px-4 pb-4">
          <model-global-message
            :global-errors="globalErrors"
            :message="message"
            @clearMessages="clearMessages()"/>
          <div class="form-group text-center mb-2">
            <div class="mx-auto mb-4 mt-3 text-center">
              <p class="font-size-14 text-white mb-4" style="line-height: 1.5; opacity: 0.9;">
                You will not be charged until the creator accepts your request. If your bank requires verification, we will notify you to complete the purchase. The creator may also decline or send you a counter-offer.
              </p>
            </div>
            <div class="text-center mt-3 w-100">
              <button @click="saveCustomRequest()"
                      class="btn btn-primary-gradient"
                      style="min-width: 160px; border-radius: 12px;">
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {customerCustomRequestMixin} from "@/mixin/customer-custom-request-mixin";
import {SERVICE_CONTENT} from "@/properties/micro-service";

export default {
  name: "ModelCustomerCustomRequestConfirm",
  mixins: [customerCustomRequestMixin],
  methods: {
    show(customRequest, customerId) {
      this.clearMessages();
      this.customRequest = customRequest;
      this.customerId = customerId;
      $('#confirm_customer_offer').modal();
    },
    hide() {
      $('#confirm_customer_offer').modal('hide');
    },
    saveCustomRequest() {

      //api/v1/customers/{customerId}/custom-request/
      console.log(this.customRequest);
      let url = `${SERVICE_CONTENT}/api/v1/customers/${this.customerId}/custom-request/`;
      this.postData(url, this.customRequest, (data) => {
        this.hide();
        this.$store.dispatch('setMessage', 'Custom request submitted successfully!');
        this.$emit("savedCustomRequest", this.customRequest);
      });
     /* this.hide();
      this.$emit("savedCustomRequest", this.customRequest);*/
    },
    back() {
      this.hide();
      this.$emit('back');
    }
  }
}
</script>


